import { createAction, createSlice } from "@reduxjs/toolkit";

const getDiscountsSlice = createSlice({
  name: "getDiscounts",
  initialState: { data: [], processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data.data;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getDiscountsSlice;
const getDiscountsAction = createAction(name);

export {
  getDiscountsAction,
  actions as getDiscountsActions,
  reducer as getDiscountsReducer,
};
